import React, { useState } from "react";
import { RCCButton, RCCGrid, RCCProgress, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import CardBadgesContent from "src/components/DashboardComponents/DefaultDashboardComponents/CardBadgesContent";
import CardContentSquares from "src/components/DashboardComponents/DefaultDashboardComponents/CardContentSquares";
import CardSquares from "src/components/DashboardComponents/DefaultDashboardComponents/CardSquares";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";
import { IDashboardIndicatorsData } from "../interface";

const DashboardCardsIndicators: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();
	const [dataIndicators, setDataIndicators] = useState<IDashboardIndicatorsData>({
		notOnTarget: 0,
		onTarget: 0,
		total: 0,
		withoutValue: 0
	} as IDashboardIndicatorsData);

	const { loading } = useEffectFetchData<IDashboardIndicatorsData[]> (
		"DashboardIndicators/List", 
		{ group: false },
		({ data }) => {
			if(data && data.length > 0)
				setDataIndicators(data[0]);
		}
	);

	const percent = (value: number, total: number) => total === 0 ? Number((0).toFixed(2)) : Number(((value / total) * 100).toFixed(2));

	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Andamento Indicadores")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<Link to="/indicators/panel">
					<RCCTooltip
						text={translate("Painel de indicadores")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="indicators"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
				<Link to="/indicators/presentation">
					<RCCTooltip
						text={translate("Apresentação de indicadores")}
						color="grey"
					>
						<RCCButton 
							color="transparent"

							icon={{
								name: "presentationChartBar",
								color: "var(--app-icons-color)"
							}}
						/>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>
			<DefaultBody>
	
				<RCCGrid container item justifyContent="flex-end" alignItems="center">
					<CardBadgesContent>
						<span className="default-color-font">  {translate("Total")}  {dataIndicators.total}</span>
					</CardBadgesContent>  
				</RCCGrid> 
				<CardContentSquares>
					<CardSquares>
						<RCCProgress 
							layout="circle"
							value={percent(dataIndicators.withoutValue,dataIndicators.total)}
							color="var(--red)"
							width="70px"
						/>
						<span className="value">{dataIndicators.withoutValue}</span> 
						<span className="text"> {translate("Sem valor")} </span>
					</CardSquares>
					<CardSquares>
						<RCCProgress 
							layout="circle"
							value={percent(dataIndicators.notOnTarget,dataIndicators.total)}
							color="var(--yellow)"
							width="70px"
						/>
						<span className="value">{dataIndicators.notOnTarget}</span>
						<span className="text"> {translate("Não atingiu")} </span>
					</CardSquares>
					<CardSquares>
						<RCCProgress 
							layout="circle"
							value={percent(dataIndicators.onTarget,dataIndicators.total)}
							color="var(--green)"
							width="70px"
						/>
						<span className="value">{dataIndicators.onTarget}</span>
						<span className="text"> {translate("Atingiu a meta")} </span>
					</CardSquares>
				</CardContentSquares>
	
			</DefaultBody>
		</DefaultContainer>
	);};

export default DashboardCardsIndicators;
